import React from 'react';
import cn from 'classnames';
import styles from './styles.module.css.json';
/**
 * @example Button types
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <div style={{ marginBottom: 'var(--spacing-m)' }}>
 *     <Button buttonType="muted">Submit</Button>{' '}
 *     <Button buttonType="primary">Submit</Button>{' '}
 *     <Button buttonType="negative">Submit</Button>
 *   </div>
 *   <div>
 *     <Button buttonType="muted" disabled>
 *       Submit
 *     </Button>{' '}
 *     <Button buttonType="primary" disabled>
 *       Submit
 *     </Button>{' '}
 *     <Button buttonType="negative" disabled>
 *       Submit
 *     </Button>
 *   </div>
 * </Canvas>;
 * ```
 *
 * @example Full-width
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <Button fullWidth>Submit</Button>
 * </Canvas>;
 * ```
 *
 * @example Sizing
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <Button buttonSize="xxs">Submit</Button>{' '}
 *   <Button buttonSize="xs">Submit</Button>{' '}
 *   <Button buttonSize="s">Submit</Button>{' '}
 *   <Button buttonSize="m">Submit</Button>{' '}
 *   <Button buttonSize="l">Submit</Button>{' '}
 *   <Button buttonSize="xl">Submit</Button>{' '}
 * </Canvas>;
 * ```
 *
 * @example Icons
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <div style={{ marginBottom: 'var(--spacing-m)' }}>
 *     <Button leftIcon={<PlusIcon />}>Submit</Button>
 *   </div>
 *   <div style={{ marginBottom: 'var(--spacing-m)' }}>
 *     <Button rightIcon={<ChevronDownIcon />}>Options</Button>
 *   </div>
 *   <div>
 *     <Button leftIcon={<PlusIcon />} />
 *   </div>
 * </Canvas>;
 * ```
 */
export function Button(_a) {
    var _b;
    var children = _a.children, className = _a.className, disabled = _a.disabled, _c = _a.buttonType, buttonType = _c === void 0 ? 'muted' : _c, _d = _a.buttonSize, buttonSize = _d === void 0 ? 'm' : _d, fullWidth = _a.fullWidth, onClick = _a.onClick, style = _a.style, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, _e = _a.type, type = _e === void 0 ? 'button' : _e;
    return (React.createElement("button", { type: type, className: cn(styles.button, styles["buttonType-" + buttonType], styles["buttonSize-" + buttonSize], (_b = {},
            _b[styles.disabled] = disabled,
            _b[styles.fullWidth] = fullWidth,
            _b), className), disabled: disabled, onClick: onClick, style: style },
        leftIcon && (React.createElement("span", { className: styles['button__leftIcon'] }, leftIcon)),
        children && React.createElement("span", null, children),
        rightIcon && (React.createElement("span", { className: styles['button__rightIcon'] }, rightIcon))));
}
export function ButtonLink(_a) {
    var _b;
    var children = _a.children, href = _a.href, _c = _a.target, target = _c === void 0 ? '_blank' : _c, className = _a.className, _d = _a.buttonType, buttonType = _d === void 0 ? 'muted' : _d, _e = _a.buttonSize, buttonSize = _e === void 0 ? 'm' : _e, onClick = _a.onClick, fullWidth = _a.fullWidth, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, style = _a.style;
    return (React.createElement("a", { href: href, target: target, className: cn(styles.button, styles["buttonType-" + buttonType], styles["buttonSize-" + buttonSize], (_b = {},
            _b[styles.fullWidth] = fullWidth,
            _b), className), style: style, onClick: onClick },
        leftIcon && (React.createElement("span", { className: styles['button__leftIcon'] }, leftIcon)),
        children && React.createElement("span", null, children),
        rightIcon && (React.createElement("span", { className: styles['button__rightIcon'] }, rightIcon))));
}
//# sourceMappingURL=index.js.map